import { yupResolver } from "@hookform/resolvers/yup";
import { t } from "i18next";
import * as yup from "yup";

export type ProfileFormValues = {
  accountType: "private" | "business";
  street?: string | null;
  houseNumber?: string | null;
  postalCode?: string | null;
  city?: string | null;
  companyName?: string | null;
  taxNumber?: string | null;
};

export const profileFormSchema: yup.ObjectSchema<ProfileFormValues> = yup
  .object({
    accountType: yup
      .mixed<"private" | "business">()
      .oneOf(["private", "business"], t("profilePage.common.required"))
      .required(t("profilePage.common.required")),
    street: yup.string().required(t("profilePage.common.required")),
    houseNumber: yup.string().required(t("profilePage.common.required")),
    postalCode: yup.string().required(t("profilePage.common.required")),
    city: yup.string().required(t("profilePage.common.required")),
    companyName: yup.string().when("accountType", {
      is: "business",
      then: (schema) =>
        schema.trim().required(t("profilePage.common.required")),
      otherwise: (schema) => schema.optional().nullable(),
    }),
    taxNumber: yup.string().optional().nullable(),
  })
  .required();

export const profileFormResolver = yupResolver(profileFormSchema);
